import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getSecureAccounts } from '../Action/api';

const mapAccount = (acc) => ({
  appName: acc.appname || '',
  accountName: acc.accountname || '',
  purpose: acc.purpose || '',
  description: acc.description || '',
  status: acc.status || '',
  username: acc.username || '',
  registeredEmail: acc.registeredemail || '',
  registeredPhone: acc.registeredphonenumber || '',
  password: acc.passwordencrypted ? '********' : (acc.password || ''),
  passwordEncrypted: acc.passwordencrypted || '',
  _originalPassword: acc.password || '',
  mfaEnabled: acc.mfaenabled === 'true' || acc.mfaenabled === true,
  mfaMethod: acc.mfamethod || '',
  accessLevel: acc.accesslevel || '',
  assignedTo: acc.assignedto || '',
  credentialExpiry: acc.credentialexpirydate || '',
  passwordLastUpdated: acc.passwordlastupdated || '',
  rotationRequired: acc.rotationrequired === 'true' || acc.rotationrequired === true,
  createdBy: acc.createdby || '',
  createdAt: acc.createdat || '',
  updatedBy: acc.updatedby || '',
  updatedAt: acc.updatedat || '',
  lastAccessedAt: acc.lastaccessedat || '',
  notes: acc.notes || '',
  secureAccountId:
    acc.secure_account_id ||
    acc.secureAccountId ||
    acc.secureaccountid ||
    acc.id ||
    acc._id ||
    '',
});

export const fetchSecureAccounts = createAsyncThunk(
  'secureAccounts/fetchSecureAccounts',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSecureAccounts();
      if (res?.success) {
        return (res.data || []).map(mapAccount);
      }
      return rejectWithValue(res?.message || 'Failed to fetch secure accounts');
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to fetch secure accounts');
    }
  }
);

const secureAccountsSlice = createSlice({
  name: 'secureAccounts',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
    lastFetchedAt: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSecureAccounts.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSecureAccounts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload || [];
        state.lastFetchedAt = Date.now();
        state.error = null;
      })
      .addCase(fetchSecureAccounts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch secure accounts';
      });
  },
});

export default secureAccountsSlice.reducer;
